import { I18n } from 'aws-amplify';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';

import './BusinessAppDetail.css';

import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import IconPreview from '@/component/common/layout/gNav/icon/IconPreview';
import { getPublicAPI } from '@/service/publicService';
import localStorageUtil from '@/common/utils/localStorageUtil';
import LoadingPanel from '@/component/common/LoadingPanel';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { buildShareLinkBusinessApp } from '../handler/PanelManagementHandler';
import MuiTooltip from '@/component/common/MuiTooltip';

function BusinessAppDetail(props) {
    const { ticketId }  = props;

    const [appDetail, setAppDetail] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isShowPopUpReload, setIsShowPopUpReload] = useState(false);

    useEffect(() => {
        if (!ticketId) return;
        setIsLoading(true);

        let requestParams = {
            corporationInuseId: localStorageUtil.getAffiliationOrganization(),
            projectInuseId: localStorageUtil.getSelectedProjectId(),
            userId: localStorageUtil.getUserDetailId(),
            ticketId: ticketId,
            getApiType: Constant.GET_API_PUBLIC_TYPE.GET_TICKET_BUSINESS_APP_DETAIL
        };
        getPublicAPI(null, requestParams)
            .then(response => {
                const app = Utils.convertJSONDataToObject(response.payload);
                if (Utils.isEmptyObject(app)) {
                    setIsShowPopUpReload(true);
                    return;
                }
                if (!Utils.isEmptyObject(app && app.appSrc)) {
                    const cdnUrl = `${process.env.REACT_APP_CLOUD_FRONT_URL}/${app.appSrc}?v=${Date.now()}`;
                    setAppDetail({
                        ...app,
                        previewUrl: cdnUrl
                    })
                }
            })
            .catch(error => {
                console.log('✅ >>> error :', error);
                setIsShowPopUpReload(true);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [ticketId]);

    return (
        <>
            <LoadingPanel isLoading={isLoading} />
            <div className="business-app-detail-wrapper">
                <div className="business-app-detail-header">
                    <MuiTooltip title={I18n.get('OPEN_ON_NEXT_TAB')}>
                        <button
                            className="btn-reset-default app-item-open-view-app-wrapper"
                            onClick={() => {
                                if (!appDetail?.appSrc) return;
                                const shareLink = buildShareLinkBusinessApp(appDetail?.appSrc)
                                window.open(shareLink, '_blank')
                            }}
                        >
                            <IconPreview />
                        </button>
                    </MuiTooltip>
                </div>
                <div className="business-app-preview">
                    {appDetail?.previewUrl && (
                        <iframe
                            title="business-app-detail"
                            className="business-app-source"
                            style={{
                                width: '100%',
                                height: '99%',
                                minHeight: '600px',
                            }}
                            src={appDetail?.previewUrl}
                            allow={Constant.IFRAME_ALLOW_PERMISSIONS}
                            allowfullscreen
                        />
                    )}
                </div>
            </div>

            {/* Confirm */}
            <ConfirmDialog
                isOpen={isShowPopUpReload}
                msgConfirm={I18n.get('COMMSG030')}
                okCallBack={() => {
                    setIsShowPopUpReload(false);
                    window.location.reload()
                }}
            />
        </>
    );
}

BusinessAppDetail.propTypes = {
    ticketId: PropTypes.string,
};

export default BusinessAppDetail;
